import * as React from 'react';
import { Form, Field } from 'formik';
import * as Yup from 'yup';
import decimal from '~/lib/normalize/decimal';
import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';
import TransactionHeader from './TransactionHeader';


const TransactionAmountSchema = Yup.object().shape({
  amount: decimal()
    .typeError('Amount must be a valid number')
    .required('Required'),
  code: Yup.string()
    .required('Required'),
});


const TransactionFooter = () => {
  return (
    <div className="m__foot app--md__box">
      <div className="m__foot__btns">
        <button
          className="btn btn--lgry btn--xlg "
          type="submit"
        >
          Process Payment
        </button>
      </div>
    </div>
  )
};


const TransactionAmountOnePage = (props) => {
  const { initialValues, onBack, onHelp, onSubmit, getDataForm } = props;

  const handleBack = (e) => {
    e.preventDefault();
    if (onBack) onBack();
  };

  const handleHelp = (e) => {
    e.preventDefault();
    if (onHelp) onHelp();
  };

  const handleOnSubmit = (data) => {
    if (getDataForm) getDataForm(data);
    return onSubmit(TransactionAmountSchema.cast(data));
  };
  return (
    <div>
      <TransactionHeader
        onBack={handleBack}
        onHelp={handleHelp}
        title="New Transaction"
        hasInfo
      />
      <div className="m__body app--md__box">
        <div className="m__body__titl">New Payment</div>

        <FormikForm
          initialValues={initialValues}
          onSubmit={handleOnSubmit}
          validationSchema={TransactionAmountSchema}
          render={() => {
            return (
              <Form className="form__cont">
                <Field
                  name="amount"
                  label="Payment Amount"
                  type="text"
                  component={Input}
                  className="input input--sm input--sign"
                  inputSign="$"
                />

                <Field
                  name="code"
                  label="Express Code"
                  type="text"
                  component={Input}
                  className="input input--sm"
                />

                <TransactionFooter />
              </Form>
            );
          }}
        />
      </div>
    </div>
  );
};

export default TransactionAmountOnePage;
